import React, { useEffect, useState } from "react";
import ReactDOM from 'react-dom';
export function Modal({ open, children, className }) {
    const [portalEl, setPortalEl] = useState(null);
    useEffect(() => {
        let backdrop = document.querySelector('div.ltg-modal-backdrop');
        if (!open && backdrop) {
            backdrop.remove();
            setPortalEl(null);
            return;
        }
        if (!open)
            return;
        let portal = backdrop;
        if (!portal) {
            portal = document.createElement('div');
            portal.classList.add('ltg-modal-backdrop', className);
            document.body.append(portal);
        }
        setPortalEl(portal);
    }, [open]);
    if (portalEl && open) {
        return ReactDOM.createPortal(React.createElement(ModalContent, null, children), portalEl);
    }
    if (!open)
        return null;
}
function ModalContent({ children }) {
    return (React.createElement("div", { className: "ltg-modal-wrap ltg-modal-responsive-layout" },
        React.createElement("div", { className: "ltg-modal-content" }, children)));
}
